import { render, staticRenderFns } from "./right-arrow-icon-blue.vue?vue&type=template&id=52a74d90&scoped=true&lang=pug&"
import script from "./right-arrow-icon-blue.vue?vue&type=script&lang=js&"
export * from "./right-arrow-icon-blue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a74d90",
  null
  
)

export default component.exports